const NAMESPACE = 'ui-search-map-results';

const STOPPED_SPEED = 0;
const ANIMATED_SPEED = 500;

export { NAMESPACE, STOPPED_SPEED, ANIMATED_SPEED };
